/** Prints a small brand banner in the browser console on app start. */
export function displayCareConsoleArt() {
  console.log(
    "%cClinova%c hospital management system",
    "color: #2563eb; font-weight: bold; font-size: 16px;",
    "color: #64748b;",
  );
}
